import React, { useEffect } from 'react';
import { MapContainer, TileLayer, Marker, Popup, useMap } from 'react-leaflet';
import L from 'leaflet';
import 'leaflet/dist/leaflet.css';
interface LocationMapProps {
  lat: number;
  lng: number;
  label?: string;
  zoom?: number;
}
// Custom electric-blue pin SVG icon
const prtIcon = L.divIcon({
  className: 'prt-map-marker',
  html: `
    <div style="position: relative; width: 40px; height: 50px;">
      <div style="
        width: 40px;
        height: 40px;
        background: #14B3ED;
        border: 3px solid #0D0D0D;
        border-radius: 50% 50% 50% 0;
        transform: rotate(-45deg);
        box-shadow: 0 4px 12px rgba(20, 179, 237, 0.5);
        display: flex;
        align-items: center;
        justify-content: center;
      ">
        <div style="
          transform: rotate(45deg);
          color: white;
          font-family: 'Bebas Neue', sans-serif;
          font-size: 14px;
          font-weight: bold;
          letter-spacing: 0.05em;
        ">PRT</div>
      </div>
    </div>
  `,
  iconSize: [40, 50],
  iconAnchor: [20, 50],
  popupAnchor: [0, -50]
});
function ResizeFix() {
  const map = useMap();
  useEffect(() => {
    const timer = setTimeout(() => map.invalidateSize(), 100);
    return () => clearTimeout(timer);
  }, [map]);
  return null;
}
export function LocationMap({
  lat,
  lng,
  label = 'PRT',
  zoom = 15
}: LocationMapProps) {
  return <MapContainer center={[lat, lng]} zoom={zoom} scrollWheelZoom={false} style={{
    height: '100%',
    width: '100%',
    background: '#0D0D0D'
  }} className="z-0" data-id="element-156">
      <ResizeFix data-id="element-157" />
      <TileLayer attribution='&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> &copy; <a href="https://carto.com/attributions">CARTO</a>' url="https://{s}.basemaps.cartocdn.com/dark_all/{z}/{x}/{y}{r}.png" data-id="element-158" />
      <Marker position={[lat, lng]} icon={prtIcon} data-id="element-159">
        <Popup data-id="element-160">
          <strong data-id="element-161">{label}</strong>
          <br data-id="element-162" />
          6348 S Higley Rd, Gilbert, AZ
        </Popup>
      </Marker>
    </MapContainer>;
}